import { FC, useState, createContext, useContext, ReactNode } from 'react'

type SidebarContextType = {
  sidebarToggle: boolean
  toggleSidebar: () => void
  closeSidebar: () => void
  isCollapsed: boolean
  toggleCollapse: () => void
}

export const SidebarContext = createContext<SidebarContextType>({} as SidebarContextType)

export const SidebarProvider: FC<{ children?: ReactNode }> = ({ children }) => {
  const [sidebarToggle, setSidebarToggle] = useState(false)
  const [isCollapsed, setIsCollapsed] = useState(() => {
    return localStorage.getItem('navCollapsed') === 'true'
  })

  const toggleSidebar = () => setSidebarToggle((prev) => !prev)
  const closeSidebar = () => setSidebarToggle(false)

  const toggleCollapse = () => {
    setIsCollapsed((prev) => {
      const next = !prev
      localStorage.setItem('navCollapsed', String(next))
      return next
    })
  }

  return (
    <SidebarContext.Provider value={{ sidebarToggle, toggleSidebar, closeSidebar, isCollapsed, toggleCollapse }}>
      {children}
    </SidebarContext.Provider>
  )
}

export const useSidebar = () => useContext(SidebarContext)
